// TODO: Move to /web/src/flows/
import { AddCard } from "components/AddCard";
import { AddPM } from "components/AddPM";
import KYC2 from "components/KYC2";
import { Payout, Purchase } from "components/PaymentMethods";
import { Checkout } from "components/Checkout";
import TxnDetails from "components/TxnDetails";
import { TOS } from "components/TOS";
import PaymentSelectionFlow from "flows/PaymentSelection";
import PaymentMethodManagementFlow from "flows/PaymentMethodManagement";
import TxnHistoryFlow from "flows/TxnHistory";
import Deposit from "flows/Deposit";
import PayoutV2 from "flows/PayoutV2";
import GDPR from "flows/GDPR";
import SessionID from "flows/SessionID";

import * as FLOWS from "flows/constants";

export const flows = {
  [FLOWS.ADDCARD]: AddCard,
  [FLOWS.ADDPM]: AddPM,
  [FLOWS.DEPOSIT]: Deposit,
  [FLOWS.PAYOUTV2]: PayoutV2,
  [FLOWS.GDPR]: GDPR,
  [FLOWS.PAYMENT_SELECTION]: PaymentSelectionFlow,
  [FLOWS.PAYMENT_METHOD_MANAGEMENT]: PaymentMethodManagementFlow,
  [FLOWS.PAYOUT]: Payout,
  [FLOWS.PURCHASE]: Purchase,
  [FLOWS.CHECKOUT]: Checkout,
  [FLOWS.KYC2]: KYC2,
  [FLOWS.TXNHISTORY]: TxnHistoryFlow,
  [FLOWS.TXNDETAILS]: TxnDetails,
  [FLOWS.TOS]: TOS,
  [FLOWS.SESSION_ID]: SessionID,
};
